var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudgetoLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.2 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #01b0f1;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.6,18.2c-2.6,0-4.7-2.1-4.7-4.7s1.7-4.3,4-4.6V3.3c-5.3.3-9.6,4.8-9.6,10.2s4.6,10.2,10.2,10.2,6.4-1.7,8.3-4.2l-4.9-2.8c-.9.9-2,1.4-3.4,1.4h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.9,11.7l5.3-1.8c-1.4-3.7-4.8-6.3-8.9-6.6v5.6c1.6.2,3,1.3,3.6,2.8h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.3,13.5c0,.8-.2,1.5-.5,2.2l4.9,2.7c.8-1.5,1.2-3.1,1.2-4.9s-.1-1.6-.3-2.3l-5.3,1.8v.5h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,18.1c0,3.5-2.9,5.6-8.4,5.6H3.3V3.3h10.4c5.4,0,8,2.2,8,5.3s-1,3.5-2.7,4.4c2.3.8,3.7,2.6,3.7,5h0ZM9.1,7.5v3.9h4c1.9,0,2.9-.7,2.9-2s-1-2-2.9-2h-4ZM16.9,17.5c0-1.4-1.1-2.1-3-2.1h-4.8v4.1h4.8c2,0,3-.7,3-2.1h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,3.3h9.7c6.8,0,11.4,3.9,11.4,10.2s-4.6,10.2-11.4,10.2h-9.7s0-20.4,0-20.4ZM55.8,19.1c3.5,0,5.8-2.1,5.8-5.6s-2.3-5.6-5.8-5.6h-3.7v11.2h3.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.1,13.1h4.9v8.1c-2.3,1.6-5.4,2.5-8.2,2.5-6.3,0-10.8-4.2-10.8-10.2s4.6-10.2,10.9-10.2,6.7,1.3,8.6,3.6l-3.5,3.2c-1.3-1.5-2.9-2.2-4.8-2.2-3.4,0-5.6,2.2-5.6,5.6s2.2,5.6,5.6,5.6,2-.2,3-.6v-5.4h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.9,7.9h-6.3V3.3h18.3v4.6h-6.2v15.9h-5.8V7.9h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.2,19.2v4.5h-16.4V3.3h16v4.5h-10.3v3.4h9.1v4.3h-9.1v3.7h10.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,14.4V3.3h5.7v10.9c0,3.4,1.4,4.8,3.8,4.8s3.8-1.4,3.8-4.8V3.3h5.6v11.1c0,6-3.5,9.3-9.4,9.3s-9.4-3.4-9.4-9.3h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetoLogoWhite);
export default __webpack_public_path__ + "static/media/Budgeto Logo_ white.65aa22f3ba63f65b326f1a6166ba13c4.svg";
export { ForwardRef as ReactComponent };